import React from 'react';

class QuickView extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="rel quick__container">
        <div
          className={` x abs y top left z1`}
          style={{ backgroundColor: data.color }}
        />
        <div className="container--xl ma rel z2 p15">
          <h4 className="caps">
            Quick View: <span className="sans">{data.title}</span>
          </h4>
          <div className="quick__items f fw container--m jcs ais">
            {data.listItems.map(item => (
              <div key={Math.random()}>
                <h5 className="caps mb05 ls">{item.fields.title}</h5>
                <h4 className="m0 p0">{item.fields.supportingText}</h4>
              </div>
            ))}
          </div>
        </div>
        <div className="container--xl ma rel p15">
          <img
            src={data.image.fields.file.url}
            className="abs quick__image right bottom"
            alt=""
          />
        </div>
      </div>
    );
  }
}

export default QuickView;
